module.exports = function(logs) {
	"use strict";
	logs
  .controller('logsController', logsController);
	logsController.$inject = ["escapeElastic","config","$scope","$rootScope","getDataService","jQuery","refreshtokenService","alertService","serverError","authtokenService","NgTableParams","$state","postDataService","offlineError"];
	
  function logsController(escapeElastic,config,$scope,$rootScope,getDataService,jQuery,refreshtokenService,alertService, serverError, authtokenService, NgTableParams, $state, postDataService, offlineError) {
    var vmlg = this;
    var $data;
    var state = 'logs';
    vmlg.logModalShow = false;
    vmlg.logObj = null;
    vmlg.selectedUser = {value:'default'};
    vmlg.selectedMethod = {value:'default'};
    $rootScope.emptyTable = false;
    vmlg.logModalOpen = function(log) {
        $rootScope.modalShow = true;
        vmlg.logObj = log;
        vmlg.logModalShow = true;
    }
    vmlg.filtersMustArray = [];
    vmlg.closeLogs = function() {
        $rootScope.modalShow =false;
        vmlg.logModalShow = false;
    }
    $scope.ranges = {
      'Today': [moment().startOf('day'), moment()],
      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
      'Last 7 days': [moment().subtract('days', 7), moment()],
      'Last 30 days': [moment().subtract('days', 30), moment()],
      'This month': [moment().startOf('month'), moment().endOf('month')],
      'All days':[moment().subtract('year',5),moment()]
    };
    var getUsersFunction = function() {
      getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
        vmlg.allUsers = data.users;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getUsersFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
              });
        } else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      });
    }
    getUsersFunction();
    vmlg.tableReloadFunction = function(page) {
      vmlg.tableParams = new NgTableParams({
            page: page || 1,
            count: 20,
        }, {
        getData: function(params) {
          vmlg.changeDate = function(value) {
            vmlg.dateRangevalue = value;
            if(vmlg.dateRangevalue) {
              if(value.startDate && value.endDate) {
                vmlg.date_start = value.startDate.format('x');
                vmlg.date_end = value.endDate.format('x');
                console.log(vmlg.date_start)
                console.log(vmlg.date_end)
              }
            } else {
                vmlg.date_start = null;
                vmlg.date_end = null;
            }
          }
          var reloadTableFunction = function() {
            params.page(1);
            vmlg.tableParams.reload();
          }
          vmlg.resetAllFilters =function() {
            vmlg.filtersMustArray = [];
            vmlg.selectedUser = {value:'default'};
            vmlg.selectedMethod = {value:'default'};
            vmlg.bodyLog = null;
            vmlg.pathLog = null;
            vmlg.date_start = null;
            vmlg.date_end = null;
            $scope.$broadcast('clear-daterange',true);
            reloadTableFunction();
          } 
          vmlg.postFilter = function() {
            vmlg.filtersMustArray = [];
            if(vmlg.selectedUser.value != 'default') {
              vmlg.filtersMustArray.push({"query_string": {"default_field": "user","query": vmlg.selectedUser.value}})
            }
            if(vmlg.selectedMethod.value != 'default') {
              vmlg.filtersMustArray.push({"match": {"method": vmlg.selectedMethod.value}})
            }
            if(vmlg.bodyLog) {
              var variousLog = escapeElastic(vmlg.bodyLog);
              vmlg.filtersMustArray.push({"query_string": {"fields": [ "body", "header" ],"query": variousLog+'*', "default_operator": "AND"}});
            }
            if(vmlg.pathLog) {
              var pathLog = escapeElastic(vmlg.pathLog);
              vmlg.filtersMustArray.push({"query_string": {"default_field": "path","query": pathLog+'*', "default_operator": "AND"}});
            }
            if(vmlg.date_start) {
              vmlg.filtersMustArray.push({"range" : {"uts" : {"gte" : vmlg.date_start,"lte" : vmlg.date_end}}})
            }
            reloadTableFunction();
          }
          var query = {
            "from" : (params.page()-1)*params.count(), 
            "size" : params.count(),
            "query": {
              "bool": {
                "must":  vmlg.filtersMustArray
              }
            }
          }
 
          $rootScope.hasLoaded = false;
          return postDataService.save({
              param1:state, 
              sort: 'uts:desc'
            },
              JSON.stringify(query)
            ).$promise.then(function(response){
            $data = response.hits.hits;
            params.total(response.hits.total);
            params.numPages(Math.ceil(response.hits.total/params.count()));
            if($data.length>0) {
              $rootScope.emptyTable = false;
            } else {
              $rootScope.emptyTable = true;
            }
            $rootScope.hasLoaded = true;
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
              function(answer) {
               
                if(answer==200) {
                  vmlg.tableReloadFunction(params.page());
                }
                // do something
              },
              function(error) {
              },
              function(progress) {
               // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
          });
        }    
      });
    }
    vmlg.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }    
}	



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/logsModule/js/logsController.js
// module id = 508
// module chunks = 0